import { StaffingRequestTemplateType } from 'works/graphql/staffing-request-template';
import moment from 'moment/moment';

const formattedStaffingRequestType = (staffingRequestType: string) =>
  staffingRequestType === 'on_demand' ? 'On Demand' : 'Long Term';

export function formatWorksListTemplates(
  staffingRequestTemplate: StaffingRequestTemplateType
) {
  const {
    id,
    name,
    organizationUnit,
    externalId,
    staffingRequestType,
    role,
    updatedAt,
    canArchive,
  } = staffingRequestTemplate;

  return {
    key: id,
    name: name,
    organizationUnit: organizationUnit.name,
    externalId: externalId || 'None',
    position: `${formattedStaffingRequestType(staffingRequestType)} - ${
      role.abbreviation
    }`,
    organizationBusiness: organizationUnit.department.organizationBusiness.name,
    dateModified: moment(updatedAt).format('MM/DD/YYYY'),
    canArchive: canArchive.value,
  };
}
